export default "__VITE_ASSET__BTh8Lz1x__"